module.exports = __webpack_public_path__ + "img/obsolete-icon.05a27363.svg";